export var NewsletterMailType;
(function (NewsletterMailType) {
    NewsletterMailType["LIFECYCLE"] = "LIFECYCLE";
    NewsletterMailType["TRANSACTIONAL"] = "TRANSACTIONAL";
})(NewsletterMailType || (NewsletterMailType = {}));
export var TransactionalMailType;
(function (TransactionalMailType) {
    TransactionalMailType["RESERVATION_CANCELED"] = "Reservation Canceled";
    TransactionalMailType["RESERVATION_CONFIRMED"] = "Reservation Confirmed";
    TransactionalMailType["RESERVATION_PENDING"] = "Reservation Pending";
    TransactionalMailType["RESERVATION_NO_SHOW_GUARANTEE"] = "Reservation No Show Guarantee";
})(TransactionalMailType || (TransactionalMailType = {}));
export var LifeCycleMailType;
(function (LifeCycleMailType) {
    LifeCycleMailType["PRE_ARRIVAL_EMAIL"] = "Pre-Arrival Email";
    LifeCycleMailType["POST_STAY_EMAIL"] = "Post-Stay Email";
    LifeCycleMailType["BIRTHDAY_EMAIL"] = "Birthday Email";
    LifeCycleMailType["OFFER_EMAIL"] = "Offer Email";
})(LifeCycleMailType || (LifeCycleMailType = {}));
export var DaysBeforeSend;
(function (DaysBeforeSend) {
    DaysBeforeSend["TODAY"] = "0";
    DaysBeforeSend["ONE_DAY"] = "1";
    DaysBeforeSend["TWO_DAYS"] = "2";
    DaysBeforeSend["THREE_DAYS"] = "3";
    DaysBeforeSend["FOUR_DAYS"] = "4";
    DaysBeforeSend["FIVE_DAYS"] = "5";
    DaysBeforeSend["SIX_DAYS"] = "6";
    DaysBeforeSend["SEVEN_DAYS"] = "7";
})(DaysBeforeSend || (DaysBeforeSend = {}));
